module.exports = __webpack_public_path__ + "static/media/mobile.d871640b.svg";